import { Component, OnInit } from '@angular/core';
import {Config} from "@cbcore/services/config/config.service";

@Component({
  selector: 'app-footer-component',
  templateUrl: './footer.html',
  standalone: true
})
export class FooterComponent implements OnInit {
  public imagePath: string;
  public hasPatents: boolean;

  constructor(private _config: Config) { }

  ngOnInit(): void {
    this.hasPatents = this._config.CONFIG.hasPatents || false;
    const imageUrl: string = this._config.CONFIG.imagesUrl;
    this.imagePath = imageUrl + '/assets/images/helpers/powered-cb-grey.png';
  }
}

